import * as React from 'react';
import styled from 'styled-components';

const Title = styled.h1`
  font-family: ${props => props.theme.fontFamily};
  font-size: calc(${props => props.theme.defaultFontSize} * 1.5);
  font-weight: 400;

  color: ${props => props.theme.lightTextColor};
`;

export const PageTitle: React.FC = () => {
  const pathname = window.location.pathname.split('/');

  switch (pathname[1]) {
    case 'professor':
      return <Title>TCC - Portal do Professor</Title>;

    case 'funcionario':
      return <Title>TCC - Funcionários</Title>;

    case 'aluno':
      return <Title>TCC - Portal do Aluno</Title>;

    default:
      return <Title>TCC</Title>;
  }
};

// const getTituloProfessor = (path: string) => {
//   switch (path) {
//     case 'agendamento':
//       return 'TCC - Agendamento de Banca';
//     default:
//       return 'TCC - Portal do Professor';
//   }
// };